import * as React from "react";
import {ReactNode} from "react";
import styled from "styled-components";
import theme from "../../assets/css/theme";
import {below} from "../../assets/css/media";
import {Ad} from "../Ad";
import {Exist} from "components";
import {IAdCreative, RotatingAd} from "../RotatingAd";
import {Syndicates} from "modules/utils/enums";
import de_advert from "assets/img/sponsor/de/bwin_fantasy_pick_em_MPU_300x250_v2.png";
import mx_advert from "assets/img/sponsor/mx/sponsor_300x250.png";
import ca_advert from "assets/img/sponsor/canada/sponsor_300x250.jpg";
import ca_advert_v2 from "assets/img/sponsor/canada/sponsor_300x250_v2.jpg";

const GAME_NAME = process.env.REACT_APP_GAME_NAME;

const SIDEBAR_ADS: Partial<Record<Syndicates, IAdCreative[]>> = {
	[Syndicates.MX]: [
		{
			href: "https://www.toyota.mx/",
			src: mx_advert,
		},
	],
	[Syndicates.CA]: [
		{
			href: "https://www.nflshop.ca/en/",
			src: ca_advert,
		},
		{
			href: "https://www.franksredhot.com/en-ca",
			src: ca_advert_v2,
		},
	],
	[Syndicates.DE_RTL]: [
		{
			href: "https://ad.doubleclick.net/ddm/trackclk/N8807.3079530NFL/B35713091.456546537;dc_trk_aid=650633395;dc_trk_cid=264588417;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=$%7BGDPR%7D;gdpr_consent=$%7BGDPR_CONSENT_755%7D;ltd=;dc_tdv=1",
			src: de_advert,
			tracking_pixel:
				"https://ad.doubleclick.net/ddm/trackimp/N8807.3079530NFL/B35713091.456546537;dc_trk_aid=650633395;dc_trk_cid=264588417;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=$%7BGDPR%7D;gdpr_consent=$%7BGDPR_CONSENT_755%7D;ltd=;dc_tdv=1?",
		},
	],
};

const sidebar_ads = SIDEBAR_ADS[GAME_NAME as Syndicates];

interface IWrapperWithSidebar {
	readonly offset_up?: boolean;
	readonly padding?: string;
	readonly position: string;
	readonly section_background?: string;
	readonly section_padding?: string;
}

const WrapperWithSidebar = styled.main`
	display: flex;
	flex-direction: ${({position}: IWrapperWithSidebar) =>
		position === "right" ? "row" : "row-reverse"};
	width: 100%;
	max-width: ${theme.content_width};
	margin: 50px auto;
	box-sizing: border-box;
	padding: 0 20px;
	position: relative;
	align-items: flex-start;
	top: ${({offset_up}: IWrapperWithSidebar) => (offset_up ? "-185px" : 0)};

	${below.desktop`
		width: 100%;
		margin: 0;
		padding: 0;
		flex-direction: column;
	`} section {
		flex: 69%;
		width: 69%;
		${({position}: IWrapperWithSidebar) =>
			position === "right"
				? "margin-right: 2.5%;"
				: "margin-left: 2.5%;"};
		background-color: ${({section_background}: IWrapperWithSidebar) =>
			section_background ? section_background : "transparent"};
		padding: ${({section_padding}: IWrapperWithSidebar) =>
			section_padding ? section_padding : 0};
		border-radius: 4px;
		box-shadow: 0 1px 2px 1px #ececec;
		${below.desktop`
			flex: 1;
			width: 100%;
			margin-right: 0;
			margin-left: 0;
		`};
	}
	aside {
		flex: 28.5%;
		display: flex;
		gap: 16px;
		flex-flow: column;
		${below.desktop`
			flex: 1;
			width: 100%;
			margin-right: 0;
			margin-left: 0;
			margin-top: 10px;
		`};

		div:first-child {
			margin-top: 0;
		}
	}

	&.low-margin-bottom {
		margin-bottom: 0;
	}
`;

interface IWrapperSkeleton {
	readonly children: React.ReactNode;
	readonly empty_sidebar?: boolean;
	readonly offset_up?: boolean;
	readonly sidebar_components?: ReactNode[];
	readonly padding?: string;
	readonly position?: string;
	readonly section_background?: string;
	readonly section_padding?: string;
	readonly hidden_sidebar_on_mobile?: boolean;
	className?: string;
}

export const ContentWithSidebar = ({
	children,
	empty_sidebar,
	sidebar_components = [],
	offset_up,
	padding,
	position = "right",
	section_background,
	section_padding,
	hidden_sidebar_on_mobile,
	className,
}: IWrapperSkeleton) => (
	<WrapperWithSidebar
		padding={padding}
		offset_up={offset_up}
		position={position}
		section_background={section_background}
		section_padding={section_padding}
		className={className}
	>
		<section>{children}</section>
		<aside className={hidden_sidebar_on_mobile ? "hidden-mobile" : ""}>
			{sidebar_ads && sidebar_ads.length ? (
				<RotatingAd creatives={sidebar_ads} />
			) : (
				<Exist when={GAME_NAME !== Syndicates.UK}>
					<Ad />
				</Exist>
			)}
			{empty_sidebar
				? null
				: sidebar_components.map((component) => component)}
		</aside>
	</WrapperWithSidebar>
);
